import clsx from 'clsx'

import MbonusImage from 'shared/images/mbonus_discount.svg'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  title?: string
}

export const MBonusDiscount = ({ title }: Props) => {
  return (
    <div className={s.container}>
      <ImageLazy
        src={MbonusImage}
        className={s.icon}
      />

      <div className={clsx(s.text, 'bold-11')}>{title}</div>
    </div>
  )
}
